import { Button, Row, Col } from 'antd';
import { Fragment } from 'react';
import AntdInput from '../../AntdInput';
import { FormElementsType } from '../helpers';

function AddressTab({
  formElements,
  inputChangedHandler,
  setCurrentTabIndex,
}: {
  formElements: FormElementsType;
  inputChangedHandler: (name: any, value: any) => void;
  setCurrentTabIndex: (index: string) => void;
}) {
  return (
    <Fragment>
      <Row justify="center" align="middle">
        <Col xs={24}>
          <AntdInput
            {...formElements.street}
            onInputChanged={inputChangedHandler}
          />
        </Col>
      </Row>

      <Row justify="center" align="middle">
        <Col xs={24}>
          <AntdInput
            {...formElements.street2}
            onInputChanged={inputChangedHandler}
          />
        </Col>
      </Row>

      <Row align="middle">
        <Col xs={24} md={12}>
          <AntdInput
            {...formElements.city}
            onInputChanged={inputChangedHandler}
          />
        </Col>
      </Row>

      <Row align="middle">
        <Col xs={24} md={12}>
          <AntdInput
            {...formElements.province}
            onInputChanged={inputChangedHandler}
          />
        </Col>
      </Row>

      <Row align="middle">
        <Col xs={24} md={12}>
          <AntdInput
            {...formElements.postalCode}
            onInputChanged={inputChangedHandler}
          />
        </Col>
      </Row>

      <Row align="middle">
        <Col xs={24} md={12}>
          <AntdInput
            {...formElements.country}
            onInputChanged={inputChangedHandler}
          />
        </Col>
      </Row>

      <Row
        justify="center"
        align="middle"
        gutter={[{ sm: 16, md: 16, lg: 16 }, { xs: 16 }]}>
        <Col xs={24} sm={12} md={8}>
          <Button
            block
            type="primary"
            htmlType="button"
            size="large"
            onClick={() => setCurrentTabIndex('1')}>
            Back
          </Button>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Button
            block
            type="primary"
            htmlType="button"
            size="large"
            onClick={() => setCurrentTabIndex('3')}>
            Next
          </Button>
        </Col>
      </Row>
    </Fragment>
  );
}

export default AddressTab;
